import { useApi } from 'api/api-context';
import { RevisionBulkActionProps } from 'components/tables/data/revision/types';
import { useMemo } from 'react';

import Button from 'components/Button';
import { IconSignature } from '@tabler/icons-react';
import { useBulkSignRevisionModal } from 'components/modals/bulk-sign-revision-modal/BulkSignRevisionModalProvider';
import { FEATURE_TOGGLE_KEP } from 'env';
import { getBulkRevisionKindGroup } from 'components/tables/data/revision/actions/bulk/kind-utils';

/**
 * Performs a bulk sign on all selected rows with status 'confirmed' or 'being-signed'.
 */
export default function BulkSignAction({ revisions }: RevisionBulkActionProps) {
  const { userId } = useApi();
  const { bulkSignRevisionModal } = useBulkSignRevisionModal();
  const kindGroup = useMemo(() => getBulkRevisionKindGroup(revisions), [revisions]);

  const availableRevisions = useMemo(
    () =>
      kindGroup === 'mixed'
        ? []
        : revisions.filter(
            ({ revisionStatus: { slug }, technician }) =>
              (slug === 'confirmed' || slug === 'being-signed') && technician?.userId === userId
          ),
    [revisions, userId, kindGroup]
  );

  /**
   * Opens the bulk sign modal with the selected revisions.
   */
  const openBulkSignModal = () => {
    bulkSignRevisionModal({ revisionIds: availableRevisions.map((revision) => revision.revisionId) });
  };

  // Only show this action if KEP feature is enabled
  if (!FEATURE_TOGGLE_KEP) {
    return <></>;
  }

  if (availableRevisions.length === 0) {
    return <></>;
  }

  return (
    <Button variant="primary" size="sm" leftIcon={<IconSignature />} onClick={openBulkSignModal}>
      Podpísať ({availableRevisions.length})
    </Button>
  );
}
